import { SystemTaskStatus, TaskCreateType, } from '@/api/logical/task_center';
import { api } from '@/api/api';
import { apis, inWindow } from '@/config';
import { jsonSafeParse } from '@/api/utils';
export class TaskCenterApiImpl {
    constructor() {
        this.name = 'taskCenterApiImpl';
        this.http = api.getDataTransApi();
        this.eventApi = api.getEventApi();
        this.storeApi = api.getDataStoreApi();
        this.systemApi = api.getSystemApi();
        this.isElectron = this.systemApi.isElectron();
        this.NOVICE_TASK_NEXT_REMIND_TIME = 'NOVICE_TASK_NEXT_REMIND_TIME';
        this.NOVICE_TASK_NAME_MAP = 'NOVICE_TASK_NAME_MAP';
        this.noviceTaskRemindIntervalHandler = {
            eventPeriod: 'long',
            handler: ob => {
                if (ob.seq > 0 && this.systemApi.getCurrentUser()) {
                    this.checkNoviceTaskRemind();
                }
            },
            id: 'noviceTaskRemindCheck',
            seq: 0,
        };
        this.mailApi = api.requireLogicalApi(apis.mailApiImpl);
    }
    init() {
        return this.name;
    }
    afterInit() {
        if (process.env.BUILD_ISEDM && inWindow() && !window.isAccountBg) {
            if (this.systemApi.getCurrentUser()) {
                this.checkNoviceTaskRemind();
            }
            this.systemApi.intervalEvent(this.noviceTaskRemindIntervalHandler);
        }
        return this.name;
    }
    errorHandler(error) {
        var _a;
        this.eventApi.sendSysEvent({
            auto: true,
            eventSeq: 0,
            eventName: 'error',
            eventLevel: 'error',
            eventData: {
                title: (error === null || error === void 0 ? void 0 : error.message) || ((_a = error === null || error === void 0 ? void 0 : error.data) === null || _a === void 0 ? void 0 : _a.message) || '网络错误',
                content: '',
                popupType: 'toast',
                popupLevel: 'error',
            },
        });
    }
    async get(url, req, config) {
        try {
            const { data } = await this.http.get(url, req, config);
            if (!data)
                throw {};
            if (!data.success)
                throw data;
            return data.data;
        }
        catch (error) {
            const { toastError = true } = config || {};
            toastError && this.errorHandler(error);
            return Promise.reject(error);
        }
    }
    async post(url, body, config) {
        config = Object.assign({ contentType: 'json', noEnqueue: false }, (config || {}));
        try {
            const { data } = await this.http.post(url, body, config);
            if (!data)
                throw {};
            if (!data.success)
                throw data;
            return data.data;
        }
        catch (error) {
            const { toastError = true } = config || {};
            toastError && this.errorHandler(error);
            return Promise.reject(error);
        }
    }
    async delete(url, req, config) {
        try {
            const { data } = await this.http.delete(url, req, config);
            if (!data)
                throw {};
            if (!data.success)
                throw data;
            return data.data;
        }
        catch (error) {
            const { toastError = true } = config || {};
            toastError && this.errorHandler(error);
            return Promise.reject(error);
        }
    }
    handleSystemTask(req) {
        console.log('handleSystemTask-req: ', req);
        const { moduleType, taskType, bizId, bizContent } = req;
        const bizData = jsonSafeParse(decodeURIComponent(bizContent));
        console.log('xxxx-bizId', bizId);
        console.log('xxxx-bizContent', bizContent);
        console.log('xxxx-bizData', bizData);
        if (moduleType === 'CONTACT_EMAIL') {
            if (taskType === TaskCreateType.UN_REPLY_CUSTOMER_EMAIL && (bizData === null || bizData === void 0 ? void 0 : bizData.mid)) {
                this.mailApi.doListMailBoxEntities({ mids: [bizData.mid], count: 1 }, true).then(res => {
                    const { data } = res;
                    if (data[0]) {
                        this.mailApi.doReplayMail(bizData.mid);
                    }
                    else {
                        this.mailApi.callWriteLetterFunc({
                            title: `RE: ${bizData.subject}`,
                            contact: [bizData.fromEmail],
                            writeType: 'reply',
                            mailType: 'common',
                        });
                    }
                });
            }
        }
        else if (moduleType === 'SITE_MANAGEMENT') {
            if (taskType === TaskCreateType.SITE_GUIDE_PUBLISH_REMINDER) {
                if (this.isElectron) {
                    this.eventApi.sendSysEvent({
                        eventName: 'routeChange',
                        eventStrData: 'gatsbyStateNav',
                        eventData: {
                            url: '#site?page=mySite',
                        },
                    });
                }
                else {
                    window.open('#site?page=mySite', '_blank');
                }
            }
        }
        else if (moduleType === 'EDM') {
            if (taskType === TaskCreateType.MARKETING_WEEKLY_TASK) {
                if (this.isElectron) {
                    this.eventApi.sendSysEvent({
                        eventName: 'routeChange',
                        eventStrData: 'gatsbyStateNav',
                        eventData: {
                            url: '#edm?page=write',
                        },
                    });
                }
                else {
                    window.open('#edm?page=write', '_blank');
                }
            }
        }
        else if (moduleType === 'GLOBAL_SEARCH') {
        }
        else {
            this.errorHandler(new Error('不支持的任务类型，请升级客户端'));
        }
    }
    sendSystemTaskCloseEvent(task) {
        this.eventApi.sendSysEvent({
            eventName: 'SystemTaskStatusUpdate',
            eventStrData: 'SystemTaskStatusUpdate',
            eventData: {
                moduleType: task.moduleType,
                taskId: task.taskId,
                taskStatus: SystemTaskStatus.CLOSE,
            },
        });
    }
    sendTaskStatusUpdateV2Event(updateDate) {
        this.eventApi.sendSysEvent({
            eventName: 'TaskStatusUpdateV2',
            eventStrData: 'TaskStatusUpdateV2',
            eventData: updateDate,
        });
    }
    getSystemTasks(req) {
        return this.get(this.systemApi.getUrl('getSystemTasks'), req);
    }
    updateSystemTaskStatus(req) {
        return this.post(this.systemApi.getUrl('updateSystemTaskStatus'), req);
    }
    getSystemTaskConfigList(req) {
        return this.get(this.systemApi.getUrl('getSystemTaskConfigList'), req);
    }
    updateSystemTaskConfigStatus(req) {
        return this.post(this.systemApi.getUrl('updateSystemTaskConfigStatus'), req);
    }
    registerNoviceTask(req, steps) {
        const { moduleType, taskType, taskId, taskName } = req;
        this.eventApi.sendSysEvent({
            eventName: 'NoviceTaskRegister',
            eventStrData: '',
            eventData: {
                moduleType,
                taskType,
                taskId,
                taskName,
                steps,
                step: 0,
                handling: true,
            },
        });
    }
    handleNoviceTask(req) {
        const { moduleType, taskType } = req;
        if (moduleType === 'GLOBAL_SEARCH') {
            if (taskType === 'FIND_CUSTOMER') {
                this.registerNoviceTask(req, [{ content: '输入你的公司经营的产品并点击搜索' }, { content: '点击查看公司官网、联系人、主营产品等详细信息' }]);
                this.eventApi.sendSysEvent({
                    eventName: 'routeChange',
                    eventStrData: 'gatsbyStateNav',
                    eventData: { url: '#wmData?page=globalSearch&from=noviceTask' },
                });
            }
        }
        else if (moduleType === 'EDM') {
            if (taskType === 'SEND_EDM_EMAIL') {
                this.registerNoviceTask(req, [{ content: '完成任务设置' }, { content: '完成邮件内容编辑' }, { content: '完成发送设置' }]);
                this.eventApi.sendSysEvent({
                    eventName: 'routeChange',
                    eventStrData: 'gatsbyStateNav',
                    eventData: { url: '#edm?page=write&from=noviceTask' },
                });
            }
            else if (taskType === 'SEND_EDM_AI_HOSTING') {
                this.registerNoviceTask(req, [{ content: '选择“一个自动开发任务”' }, { content: '编辑基础信息并提交' }, { content: '确认开发信并创建任务' }]);
                this.eventApi.sendSysEvent({
                    eventName: 'routeChange',
                    eventStrData: 'gatsbyStateNav',
                    eventData: { url: '#edm?page=aiHosting&pageTo=new&from=noviceTask' },
                });
            }
        }
        else if (moduleType === 'CONTACT') {
            if (taskType === 'CREATE_NEW_CUSTOMER') {
                this.registerNoviceTask(req, [{ content: '点击“新建客户”按钮' }, { content: '编辑对应的字段内容并点击提交' }]);
                location.hash = '/unitable-crm/custom/list?id=';
            }
            else if (taskType === 'CREATE_FOLLOWUP') {
                this.registerNoviceTask(req, [
                    { content: '点击进入客户详情页' },
                    { content: '点击新建' },
                    { content: '点击新建跟进记录' },
                    { content: '手动输入跟进记录内容' },
                    { content: '选择下次跟进时间自动创建日程提醒' },
                    { content: '点击添加' },
                ]);
                location.hash = '/unitable-crm/custom/list?id=';
            }
        }
        else {
            this.errorHandler(new Error('不支持的任务类型，请升级客户端'));
        }
    }
    setNoviceTaskNextRemindTime(time) {
        this.storeApi.put(this.NOVICE_TASK_NEXT_REMIND_TIME, `${time}`);
    }
    getNoviceTaskNextRemindTime() {
        const storeTime = this.storeApi.getSync(this.NOVICE_TASK_NEXT_REMIND_TIME).data;
        return storeTime ? +storeTime : 0;
    }
    getNoviceTaskRemind() {
        return this.get(this.systemApi.getUrl('getNoviceTaskRemind'));
    }
    checkNoviceTaskRemind() {
        return this.getNoviceTaskRemind().then(shouldRemind => {
            const nextRemindTime = this.getNoviceTaskNextRemindTime();
            shouldRemind = shouldRemind && Date.now() > nextRemindTime;
            if (shouldRemind) {
                this.eventApi.sendSysEvent({
                    eventName: 'NoviceTaskRemind',
                    eventStrData: '',
                    eventData: '',
                });
            }
        });
    }
    closeNoviceTaskRemind() {
        return this.delete(this.systemApi.getUrl('closeNoviceTaskRemind'));
    }
    getNoviceTasks() {
        return this.get(this.systemApi.getUrl('getNoviceTasks'));
    }
    finishNoviceTask(req) {
        return this.post(this.systemApi.getUrl('finishNoviceTask'), req);
    }
    getNoviceTaskTeamTasks() {
        return this.get(this.systemApi.getUrl('getNoviceTaskTeamTasks'));
    }
    getNoviceTaskTeamStats() {
        return this.get(this.systemApi.getUrl('getNoviceTaskTeamStats'));
    }
    getNoviceTaskExternUrl() {
        return this.get(this.systemApi.getUrl('getNoviceTaskExternUrl'));
    }
    getTaskRuleList(params) {
        return this.get(this.systemApi.getUrl('getTaskRuleList'), params);
    }
    createTaskRule(req) {
        return this.post(this.systemApi.getUrl('createTaskRule'), req);
    }
    getTaskRuleDetail(params) {
        return this.get(this.systemApi.getUrl('getTaskRuleDetail'), params);
    }
    getSnapshotTaskRuleDetail(req) {
        return this.post(this.systemApi.getUrl('getSnapshotTaskRuleDetail'), req);
    }
    getTaskRuleTemplate() {
        return this.get(this.systemApi.getUrl('getTaskRuleTemplate'));
    }
    updateTaskRule(data) {
        return this.post(this.systemApi.getUrl('updateTaskRule'), data);
    }
    updateTaskRuleEnableStatus(params) {
        return this.post(this.systemApi.getUrl('updateTaskRuleEnableStatus'), params, {
            params,
        });
    }
    deleteTaskRule(params) {
        return this.delete(this.systemApi.getUrl('deleteTaskRule'), params);
    }
    translateLang(data) {
        return this.post(this.systemApi.getUrl('translateLang'), data);
    }
    getSystemTaskPageList(req) {
        return this.post(this.systemApi.getUrl('getSystemTaskPageList'), req);
    }
    getSystemTaskScrollPageListV2(req) {
        return this.post(this.systemApi.getUrl('getSystemTaskScrollPageListV2'), req);
    }
    operateTask(req) {
        return this.post(this.systemApi.getUrl('operateTask'), req);
    }
    getTaskCount() {
        return this.get(this.systemApi.getUrl('getTaskCount'));
    }
    getTaskCountV2() {
        return this.get(this.systemApi.getUrl('getTaskCountV2'));
    }
    getSystemTaskPageListV2(req) {
        return this.post(this.systemApi.getUrl('getSystemTaskPageListV2'), req);
    }
    getSystemTaskScrollPageListV3(req) {
        return this.post(this.systemApi.getUrl('getSystemTaskScrollPageListV3'), req);
    }
    grtTaskStatusCount(req) {
        return this.post(this.systemApi.getUrl('grtTaskStatusCount'), req);
    }
}
const taskCenterApiImpl = new TaskCenterApiImpl();
api.registerLogicalApi(taskCenterApiImpl);
export default taskCenterApiImpl;
